import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({ locale: "fr", setLocale: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => localStorage.getItem("facow_locale") || "fr");

  useEffect(() => {
    localStorage.setItem("facow_locale", locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const t = (key) => {
    const parts = key.split(".");
    let v = translations[locale];
    for (const p of parts) {
      v = v?.[p];
      if (v === undefined) return key;
    }
    return v;
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale, t }}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
